import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import chatbotService from "./chatbotService";
//get user from local storage
// const chatbots = JSON.parse(localStorage.getItem("chatbots"));
let token = JSON.parse(localStorage.getItem("token"));
// const combinations = JSON.parse(localStorage.getItem("combinations"));
// const generation_combinations = JSON.parse(localStorage.getItem("generation_combinations"));
// const finetuning_combinations = JSON.parse(localStorage.getItem("finetuning_combinations"));
const defaultCombination = JSON.parse(
  localStorage.getItem("defaultCombination")
);
const finalCombinations = JSON.parse(localStorage.getItem("finalCombinations"));
const prompts = JSON.parse(localStorage.getItem("prompts"));

const initialState = {
  chatbots: [],
  token: token ? token : null,
  combinations: [],
  generation_combinations: [],
  finetuning_combinations: [],
  parser_combinations: [],
  agent_combinations: [],
  prompts: prompts ? prompts : [],
  selected_combinations: [],
  combinationUsed: null,
  dataTypes: {},
  isError: false,
  isSuccess: false,
  isLoading: false,
  gettingCombinations: false,
  gettingAgentCombinations: false,
  message: "",
  botData: {},
  templateBots: [],
  defaultCombination: defaultCombination ? defaultCombination : {},
  finalCombinations: finalCombinations ? finalCombinations : [],
  isFinetuning: false,
  combination_length: 1,
  agent_combination_length: 1,
  filterValues: {},
  agent_filter_values: {},
  uploadProgress: 0,
  isUploading: false,
  uploadError: null,
  agent_filters: {},
  agent_sort_order: { column: null, direction: "asc" },
};
//upload files

export const createBot = createAsyncThunk(
  "chatbot/createBot",
  async (botData, thunkAPI) => {
    try {
      // Mark upload as started
      thunkAPI.dispatch(setIsUploading(true));
      thunkAPI.dispatch(setUploadProgress(0));

      // Progress handler that updates Redux state
      const progressHandler = (progress) => {
        thunkAPI.dispatch(setUploadProgress(progress));
      };

      // Error handler that updates Redux state
      const errorHandler = (error) => {
        thunkAPI.dispatch(setUploadError(error.message));
      };

      // Call service with progress tracking
      const result = await chatbotService.createBot(botData, token, {
        onProgress: progressHandler,
        onError: errorHandler,
      });

      // Mark upload as complete
      thunkAPI.dispatch(setIsUploading(false));
      thunkAPI.dispatch(setUploadProgress(100));

      return result;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setUploadError(message));
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get bot by org
export const getBotbyOrg = createAsyncThunk(
  "chatbot/getBotbyOrg",
  async (id, thunkAPI) => {
    try {
      return await chatbotService.getBotbyOrg(id, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Add thunk for cancelling uploads
export const cancelBotUpload = createAsyncThunk(
  "chatbot/cancelBotUpload",
  async (_, thunkAPI) => {
    const cancelled = chatbotService.cancelBotUpload();
    if (cancelled) {
      thunkAPI.dispatch(resetUploadState());
    }
    return cancelled;
  }
);

//get bot by org templates
export const getBotbyOrgTemplates = createAsyncThunk(
  "chatbot/getBotbyOrgTemplates",
  async (id, thunkAPI) => {
    try {
      return await chatbotService.getBotbyOrgTemplates(id, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get bot by org templates
export const saveOptimizedBot = createAsyncThunk(
  "chatbot/saveOptimizedBot",
  async (ids, thunkAPI) => {
    try {
      return await chatbotService.saveOptimizedBot(ids, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get combinations
export const getCombinations = createAsyncThunk(
  "chatbot/getCombinations",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.getCombinations(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get generation combinations
export const getgenerationCombinations = createAsyncThunk(
  "chatbot/getgenerationCombinations",
  async (id, thunkAPI) => {
    try {
      return await chatbotService.getgenerationCombinations(id, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get generation combinations
export const getFinetuningCombinations = createAsyncThunk(
  "chatbot/getFinetuningCombinations",
  async (id, thunkAPI) => {
    try {
      return await chatbotService.getFinetuningCombinations(id, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get parser combinations
export const getParserCombinations = createAsyncThunk(
  "chatbot/getParserCombinations",
  async (id, thunkAPI) => {
    try {
      return await chatbotService.getParserCombinations(id, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//run evals
export const runEvals = createAsyncThunk(
  "chatbot/runEvals",
  async (ids, thunkAPI) => {
    try {
      return await chatbotService.runEvals(ids, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//run evals
export const runFinetuningEvals = createAsyncThunk(
  "chatbot/runFinetuningEvals",
  async (ids, thunkAPI) => {
    try {
      return await chatbotService.runFinetuningEvals(ids, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//run generation evals
export const runGenerationEvals = createAsyncThunk(
  "chatbot/runGenerationEvals",
  async (ids, thunkAPI) => {
    try {
      return await chatbotService.runGenerationEvals(ids, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//start finetuning
export const startFinetuning = createAsyncThunk(
  "chatbot/startFinetuning",
  async (ids, thunkAPI) => {
    try {
      return await chatbotService.startFinetuning(ids, token);
    } catch (error) {
      const status = error.response ? error.response.status : null;
      const message =
        (error.response && error.response.data && error.response.data.status) || // Using the 'status' field from the response data
        error.message ||
        error.toString();

      return thunkAPI.rejectWithValue({ message, status });
    }
  }
);

//start finetuning
export const getFinetuningStatus = createAsyncThunk(
  "chatbot/getFinetuningStatus",
  async (ids, thunkAPI) => {
    try {
      return await chatbotService.getFinetuningStatus(ids, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//generate Prompts
export const generatePrompts = createAsyncThunk(
  "chatbot/generatePrompts",
  async (bot_id, thunkAPI) => {
    try {
      return await chatbotService.generatePrompts(bot_id, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//generate Prompts
export const generateQueryWithProblemStatement = createAsyncThunk(
  "chatbot/generateQueryWithProblemStatement",
  async (bot_id, thunkAPI) => {
    try {
      return await chatbotService.generateQueryWithProblemStatement(
        bot_id,
        token
      );
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//initialize Combinations
export const initializeCombinations = createAsyncThunk(
  "chatbot/initializeCombinations",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.initializeCombinations(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//initialize Combinations Sync
export const initializeCombinationsSync = createAsyncThunk(
  "chatbot/initializeCombinationsSync",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.initializeCombinationsSync(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//initialize Combinations
export const initializeEmbeddingFinetuning = createAsyncThunk(
  "chatbot/initializeEmbeddingFinetuning",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.initializeEmbeddingFinetuning(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//initialize mutations
export const initializeMutations = createAsyncThunk(
  "chatbot/initializeMutations",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.initializeMutations(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get selected combinations
export const makeDefault = createAsyncThunk(
  "chatbot/makeDefault",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.makeDefault(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//delete chatbot
export const deleteChatbot = createAsyncThunk(
  "chatbot/deleteChatbot",
  async (id, thunkAPI) => {
    try {
      return await chatbotService.deleteChatbot(id, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//delete files
export const deleteFiles = createAsyncThunk(
  "chatbot/deleteFiles",
  async (ids, thunkAPI) => {
    try {
      return await chatbotService.deleteFiles(ids, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//Upload sources
export const uploadSources = createAsyncThunk(
  "chatbot/uploadSources",
  async (data, thunkAPI) => {
    try {
      // Mark upload as started
      thunkAPI.dispatch(setIsUploading(true));
      thunkAPI.dispatch(setUploadProgress(0));

      // Progress handler that updates Redux state
      const progressHandler = (progress) => {
        thunkAPI.dispatch(setUploadProgress(progress));
      };

      // Error handler that updates Redux state
      const errorHandler = (error) => {
        thunkAPI.dispatch(setUploadError(error.message));
      };

      const response = await chatbotService.uploadSources(data, token, {
        onProgress: progressHandler,
        onError: errorHandler,
      });

      // Mark upload as complete
      thunkAPI.dispatch(setIsUploading(false));
      thunkAPI.dispatch(setUploadProgress(100));

      if (response.status && response.status !== "success") {
        return thunkAPI.rejectWithValue(response.status);
      }
      return response;
    } catch (error) {
      thunkAPI.dispatch(setIsUploading(false));

      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//Upload sources
export const getDataTypes = createAsyncThunk(
  "chatbot/getDataTypes",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.getDataTypes(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//Upload sources
export const getMetadataDescription = createAsyncThunk(
  "chatbot/getMetadataDescription",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.getMetadataDescription(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get defualt combinations
export const getDefaultCombinations = createAsyncThunk(
  "chatbot/getDefaultCombinations",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.getDefaultCombinations(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//save default combinations
export const saveDefaultCombinations = createAsyncThunk(
  "chatbot/saveDefaultCombinations",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.saveDefaultCombinations(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get Finetuning Training Loss
export const getFinetuningTrainingLoss = createAsyncThunk(
  "chatbot/getFinetuningTrainingLoss",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.getFinetuningTrainingLoss(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get Finetuning Training Loss
export const cancelFinetuning = createAsyncThunk(
  "chatbot/cancelFinetuning",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.cancelFinetuning(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//edit bot name
export const updateAppName = createAsyncThunk(
  "chatbot/updateAppName",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.updateAppName(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//Upload more golden qna
export const updateGoldenResponses = createAsyncThunk(
  "chatbot/updateGoldenResponses",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.updateGoldenResponses(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//update prompt settings
export const updatePromptStatementSettings = createAsyncThunk(
  "chatbot/updatePromptStatementSettings",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.updatePromptStatementSettings(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// validate neo4j credentials
export const validateNeo4jCreds = createAsyncThunk(
  "chatbot/validateNeo4jCreds",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.validateNeo4jCreds(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get Combination Details
export const getCombinationDetails = createAsyncThunk(
  "chatbot/getCombinationDetails",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.getCombinationDetails(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get Combination Details
export const generateQuestions = createAsyncThunk(
  "chatbot/generateQuestions",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.generateQuestions(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get init cost
export const getInitCost = createAsyncThunk(
  "chatbot/getInitCost",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.getInitCost(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// get bot by id
export const getBotbyID = createAsyncThunk(
  "chatbot/getBotbyID",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.getBotbyID(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get bots by user
export const getBotsbyUser = createAsyncThunk(
  "chatbot/getBotsbyUser",
  async (id, thunkAPI) => {
    try {
      return await chatbotService.getBotsbyUser(id, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get deployed bots by user
export const getDeployedBotsbyUser = createAsyncThunk(
  "chatbot/getDeployedBotsbyUser",
  async (id, thunkAPI) => {
    try {
      return await chatbotService.getDeployedBotsbyUser(id, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get combinations eval
export const getCombinationEvalBatch = createAsyncThunk(
  "chatbot/getCombinationEvalBatch",
  async (id, thunkAPI) => {
    try {
      return await chatbotService.getCombinationEvalBatch(id, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get evaluation by combination id
export const getEvaluationByCombinationId = createAsyncThunk(
  "chatbot/getEvaluationByCombinationId",
  async (data, thunkAPI) => {
    try {
      return await chatbotService.getEvaluationByCombinationId(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Clear evaluation cache
export const clearEvaluationCache = createAsyncThunk(
  "chatbot/clearEvaluationCache",
  async (_, thunkAPI) => {
    try {
      chatbotService.clearEvaluationCache();
      return { success: true };
    } catch (error) {
      const message = error.message || "Failed to clear evaluation cache";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Clear specific evaluation from cache
export const clearSpecificEvaluationFromCache = createAsyncThunk(
  "chatbot/clearSpecificEvaluationFromCache",
  async (data, thunkAPI) => {
    try {
      chatbotService.clearSpecificEvaluationFromCache(data.tool_type, data.combination_id);
      return { success: true };
    } catch (error) {
      const message = error.message || "Failed to clear specific evaluation from cache";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Check if evaluation is cached
export const checkEvaluationCached = createAsyncThunk(
  "chatbot/checkEvaluationCached",
  async (data, thunkAPI) => {
    try {
      const isCached = chatbotService.isEvaluationCached(data.tool_type, data.combination_id);
      return { isCached };
    } catch (error) {
      const message = error.message || "Failed to check cache status";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get evaluation cache size
export const getEvaluationCacheSize = createAsyncThunk(
  "chatbot/getEvaluationCacheSize",
  async (_, thunkAPI) => {
    try {
      const cacheSize = chatbotService.getEvaluationCacheSize();
      return { cacheSize };
    } catch (error) {
      const message = error.message || "Failed to get cache size";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// get getSpecificToolById by id
export const getSpecificToolById = createAsyncThunk(
  "chatbotService/getSpecificToolById",
  async (tool_id, thunkAPI) => {
    try {
      return await chatbotService.getSpecificToolById(tool_id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAgentCombinations = createAsyncThunk(
  "chatbot/getAgentCombinations",
  async (data, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await chatbotService.getAgentCombinations(data, token);
    } catch (error) {
      const message = error.message || "Failed to fetch agent combinations";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// run agent combinations
export const runAgentEvals = createAsyncThunk(
  "chatbot/runAgentEvals",
  async (ids, thunkAPI) => {
    try {
      return await chatbotService.runAgentEvals(ids, token);
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get combinations eval
export const addCombination = createAsyncThunk(
  "chatbot/addCombination",
  async (payload, thunkAPI) => {
    try {
      return await chatbotService.addCombination(payload, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get combinations eval
export const updateCombination = createAsyncThunk(
  "chatbot/updateCombination",
  async (payload, thunkAPI) => {
    try {
      return await chatbotService.updateCombination(payload, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get combination by combination id
export const getCombinationByID = createAsyncThunk(
  "chatbot/getCombinationByID",
  async (payload, thunkAPI) => {
    try {
      return await chatbotService.getCombinationByID(payload, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);



export const getNeoProjectsByUserId = createAsyncThunk(
  "neo/getProjectsByUserId",
  async (payload, thunkAPI) => {
    try {
      return await chatbotService.getNeoProjectsByUserId(payload, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const generateBotReportNeo = createAsyncThunk(
  "neo/generateBotReportNeo",
  async (payload, thunkAPI) => {
    try {
      return await chatbotService.generateReportBotnNeo(payload, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getNeoSessionById = createAsyncThunk(
  "neo/getNeoSessionById",
  async (payload, thunkAPI) => {
    try {
      return await chatbotService.getNeoSessionById(payload, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateNeoProjectName = createAsyncThunk(
  "neo/updateNeoProjectName",
  async (payload, thunkAPI) => {
    try {
      return await chatbotService.updateNeoProjectName(payload, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteNeoProject = createAsyncThunk(
  "neo/deleteNeoProject",
  async (id, thunkAPI) => {
    try {
      return await chatbotService.deleteNeoProject(id, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const runParserEvals = createAsyncThunk(
  "chatbot/runParserEvals",
  async (
    { orgId, user_id, bot_id, parser_id, combination_id, token },
    thunkAPI
  ) => {
    try {
      return await chatbotService.runParserEvals({
        orgId,
        user_id,
        bot_id,
        parser_id,
        combination_id,
        token,
      });
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const chatbotSlice = createSlice({
  name: "chatbots",
  initialState,
  reducers: {
    resetBotState: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.message = "";
    },
    resetChatbot: (state) => {
      state.chatbots = [];
      state.combinations = [];
      state.selected_combinations = [];
      state.finetuning_combinations = [];
      state.finalCombinations = [];
      state.generation_combinations = [];
      state.prompts = [];
      state.defaultCombination = {};
      state.token = null;
      token = null;
    },
    resetCombinations: (state) => {
      state.combinations = [];
      state.finetuning_combinations = [];
      state.finalCombinations = [];
      state.generation_combinations = [];
      state.parser_combinations = [];
      state.defaultCombination = {};
    },
    sortByProperty: (state, action) => {
      if (action.payload.type === "retrieval") {
        state.combinations = action.payload.sortedCombinations;
      } else if (action.payload.type === "finetuned") {
        state.finetuning_combinations = action.payload.sortedCombinations;
      } else if (action.payload.type === "generation") {
        state.generation_combinations = action.payload.sortedCombinations;
      }
    },
    sortApplicationsByCreatedAt: (state, action) => {
      state.chatbots.combinations = action.payload.sortedApplications;
    },
    setCombinationUsed: (state, action) => {
      state.combinationUsed = action.payload;
    },
    deleteCombinatioSet: (state, action) => {
      state.chatbots = action.payload.chatbots;
    },
    setDefaultCombination: (state, action) => {
      state.defaultCombination = action.payload;
    },
    deleteBotFromTemplateBots: (state, action) => {
      const newTemplates = state.templateBots.combinations.filter((bot) => {
        return bot._id["$oid"] !== action.payload;
      });
      state.templateBots.combinations = newTemplates;
    },
    clearFilterValues: (state, action) => {
      state.filterValues = {};
    },
    updateBotData: (state, action) => {
      state.botData = action.payload;
    },
    // Add reducers for tracking upload progress
    setUploadProgress: (state, action) => {
      state.uploadProgress = action.payload;
    },
    setIsUploading: (state, action) => {
      state.isUploading = action.payload;
    },
    setUploadError: (state, action) => {
      state.uploadError = action.payload;
    },
    resetUploadState: (state) => {
      state.uploadProgress = 0;
      state.isUploading = false;
      state.uploadError = null;
    },
    setAgentCombinationFilters(state, action) {
      state.agent_filters = {
        ...state.agent_filters,
        [action.payload.column]: action.payload.value,
      };
    },
    setAgentCombinationSortOrder: (state, action) => {
      const { column, direction } = action.payload;
      state.agent_sort_order = { column, direction };
    },
    clearAllAgentCombinationFilters: (state) => {
      state.agent_filters = {};
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(createBot.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createBot.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.token =
          action?.payload?.token || JSON.parse(localStorage.getItem("token"));
      })
      .addCase(createBot.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getBotbyOrg.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBotbyOrg.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.gettingCombinations = false;
        // state.chatbots = action.payload;
        // Access the 'combinations' array from the action.payload
        const combinations = action?.payload?.combinations || [];
        // Reverse the combinations array to show the most recent ones first
        const reversedCombinations = [...combinations].reverse();
        // Update the state with the reversed combinations
        state.chatbots = {
          ...action.payload,
          combinations: reversedCombinations,
        }; // Override combinations with reversed array
      })
      .addCase(getBotbyOrg.rejected, (state, action) => {
        state.message = action.payload;
        state.isLoading = false;
        state.isError = true;
        state.gettingCombinations = false;
      })
      .addCase(getBotbyOrgTemplates.pending, (state) => {
        state.isLoading = true;
        state.gettingCombinations = true;
      })
      .addCase(getBotbyOrgTemplates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.gettingCombinations = false;
        state.templateBots = action.payload;

        // localStorage.setItem("chatbots", JSON.stringify(action.payload));
        // Access the 'combinations' array from the action.payload
        const combinations = action.payload.combinations;
        // Reverse the combinations array to show the most recent ones first
        const reversedCombinations = [...combinations].reverse();
        // Update the state with the reversed combinations
        state.chatbots = {
          ...action.payload,
          combinations: reversedCombinations,
        }; // Override combinations with reversed array
      })
      .addCase(getBotbyOrgTemplates.rejected, (state, action) => {
        console.error(action.payload);
        state.message = action.payload;
        state.isLoading = false;
        state.isError = true;
        state.gettingCombinations = false;
      })
      .addCase(saveOptimizedBot.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(saveOptimizedBot.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(saveOptimizedBot.rejected, (state, action) => {
        state.message = action.payload;
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(makeDefault.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(makeDefault.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.gettingCombinations = false;
        // localStorage.setItem("chatbots", JSON.stringify(action.payload));
        state.chatbots = action.payload;
      })
      .addCase(makeDefault.rejected, (state, action) => {
        state.message = action.payload;
        state.isLoading = false;
        state.isError = true;
        state.gettingCombinations = false;
      })
      .addCase(getCombinations.pending, (state) => {
        state.isLoading = true;
        state.gettingCombinations = true;
      })
      .addCase(getCombinations.fulfilled, (state, action) => {
        // localStorage.setItem("combinations", JSON.stringify(action.payload));
        state.combinations = action?.payload?.combinations || [];
        state.combination_length = action?.payload?.["length"] || 0;
        state.filterValues = action?.payload?.["filter_values"] || 0;
        state.isLoading = false;
        state.isSuccess = true;
        state.gettingCombinations = false;
      })
      .addCase(getCombinations.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.gettingCombinations = false;
        state.message = action.payload;
      })
      .addCase(getgenerationCombinations.pending, (state) => {
        // state.isLoading = true;
        state.gettingCombinations = true;
      })
      .addCase(getgenerationCombinations.fulfilled, (state, action) => {
        // localStorage.setItem("generation_combinations", JSON.stringify(action.payload));
        state.generation_combinations = action.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.gettingCombinations = false;
      })
      .addCase(getgenerationCombinations.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.gettingCombinations = false;
        state.message = action.payload;
      })
      .addCase(getFinetuningCombinations.pending, (state) => {
        state.isLoading = true;
        state.gettingCombinations = true;
      })
      .addCase(getFinetuningCombinations.fulfilled, (state, action) => {
        // localStorage.setItem("finetuning_combinations", JSON.stringify(action.payload));
        state.finetuning_combinations = action.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.gettingCombinations = false;
      })
      .addCase(getFinetuningCombinations.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.gettingCombinations = false;
        state.message = action.payload;
      })
      .addCase(getParserCombinations.pending, (state) => {
        state.isLoading = true;
        state.gettingCombinations = true;
      })
      .addCase(getParserCombinations.fulfilled, (state, action) => {
        // localStorage.setItem("parser_combinations", JSON.stringify(action.payload));
        state.parser_combinations = action.payload;
        state.isLoading = false;
        state.isSuccess = true;
        state.gettingCombinations = false;
      })
      .addCase(getParserCombinations.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.gettingCombinations = false;
        state.message = action.payload;
      })
      .addCase(runEvals.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(runEvals.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.combinations = state.combinations.map((combination) =>
          combination._id["$oid"] === action.payload.combination._id["$oid"]
            ? action.payload.combination // replace with the new combination
            : combination
        );
      })
      .addCase(runEvals.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(runFinetuningEvals.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(runFinetuningEvals.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.finetuning_combinations = state.finetuning_combinations.map(
          (combination) =>
            combination._id["$oid"] === action.payload.combination._id["$oid"]
              ? action.payload.combination // replace with the new combination
              : combination
        );
      })
      .addCase(runFinetuningEvals.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(runGenerationEvals.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(runGenerationEvals.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.generation_combinations = state.generation_combinations.map(
          (combination) =>
            combination._id["$oid"] === action.payload.combination._id["$oid"]
              ? action.payload.combination // replace with the new combination
              : combination
        );
      })
      .addCase(runGenerationEvals.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(startFinetuning.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(startFinetuning.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
        state.isFinetuning = true;
      })
      .addCase(startFinetuning.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getFinetuningStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getFinetuningStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.finetuning_combinations = state.finetuning_combinations.map(
          (combination) =>
            combination._id["$oid"] === action.meta.arg.combination_id
              ? {
                  ...combination,
                  status: action.payload.status, // Update the status field
                }
              : combination
        );
      })
      .addCase(getFinetuningStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(generatePrompts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(generatePrompts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.prompts = action.payload.prompts;
      })
      .addCase(generatePrompts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(initializeCombinations.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(initializeCombinations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(initializeCombinations.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(initializeCombinationsSync.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(initializeCombinationsSync.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(initializeCombinationsSync.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(initializeEmbeddingFinetuning.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(initializeEmbeddingFinetuning.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(initializeEmbeddingFinetuning.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(initializeMutations.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(initializeMutations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.combinations = action.payload.selected_combinations;
      })
      .addCase(initializeMutations.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteChatbot.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteChatbot.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload;
        // state.token = action.payload.token;
      })
      .addCase(deleteChatbot.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteFiles.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteFiles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload;
        // state.token = action.payload.token;
      })
      .addCase(deleteFiles.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(uploadSources.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(uploadSources.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload;
        // state.token = action.payload.token;
      })
      .addCase(uploadSources.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getDataTypes.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(getDataTypes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.dataTypes = {
          ...state.dataTypes,
          [action.payload.filename]: action.payload.datatypes,
        };
        // state.token = action.payload.token;
      })
      .addCase(getDataTypes.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getMetadataDescription.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(getMetadataDescription.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.metadataDescription = {
          ...state.metadataDescription,
          [action.payload.filename]: action.payload.datatypes,
        };
        // state.token = action.payload.token;
      })
      .addCase(getMetadataDescription.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getDefaultCombinations.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(getDefaultCombinations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.defaultCombination = action.payload.defaultCombination;
        // state.token = action.payload.token;
      })
      .addCase(saveDefaultCombinations.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload.status;
      })
      .addCase(updateAppName.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(updateAppName.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        const { bot_id, new_name } = action.payload; // Extract bot_id and new_name from the payload

        // Find the bot in the combinations array and update its name
        const botIndex = state.chatbots?.combinations?.findIndex(
          (bot) => bot._id["$oid"] === bot_id
        );

        if (botIndex !== -1) {
          state.chatbots.combinations[botIndex].name = new_name; // Update the bot name
        }
      })
      .addCase(updateAppName.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload.status;
      })
      .addCase(updateGoldenResponses.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(updateGoldenResponses.fulfilled, (state, action) => {
        const { payload } = action;

        // Extract the first item of the array (actual response object)
        const responseData = Array.isArray(payload) ? payload[0] : payload;

        // Ensure responseData contains qna_data
        const { qna_data } = responseData || {};
        if (!Array.isArray(qna_data)) {
          console.error("Invalid or missing qna_data:", payload);
          return;
        }

        const { bot_id } = action.meta.arg;

        const botIndex = state.chatbots?.combinations?.findIndex(
          (bot) => bot._id?.["$oid"] === bot_id
        );

        if (botIndex !== -1) {
          state.chatbots.combinations[botIndex] = {
            ...state.chatbots.combinations[botIndex],
            golden_responses: qna_data, // Replace with backend response
          };
        }
      })
      .addCase(updateGoldenResponses.rejected, (state, action) => {
        // state.isLoading = false;
        state.isError = true;
        state.message =
          action.payload?.status || "Error updating golden responses.";
      })
      .addCase(updatePromptStatementSettings.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updatePromptStatementSettings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        const { bot_id } = action.meta.arg;
        const { prompt_guidelines, have_memory } = action.meta.arg;

        // Find the index of the bot in the combinations array
        const botIndex = state.chatbots?.combinations?.findIndex(
          (bot) => bot._id?.["$oid"] === bot_id
        );

        if (botIndex !== -1) {
          // Ensure immutability by creating a new golden_responses array
          state.chatbots.combinations[botIndex] = {
            ...state.chatbots.combinations[botIndex],
            prompt_guidelines, // Update the prompt guidelines
            have_memory,
          };
        }
      })
      .addCase(updatePromptStatementSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message =
          action.payload?.status || "Error updating prompt settings.";
      })
      .addCase(saveDefaultCombinations.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(saveDefaultCombinations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;

        // the bot_id we just updated
        const { bot_id } = action.meta.arg;

        // the server returns an array of bots under payload.combinations
        const returnedBots = action.payload.combinations || [];
        // find the one we care about
        const updatedBot = returnedBots.find((b) => b._id["$oid"] === bot_id);

        if (updatedBot) {
          state.chatbots.combinations = state.chatbots.combinations.map(
            (bot) => {
              if (bot._id["$oid"] === bot_id) {
                return {
                  ...bot,
                  default_flow: updatedBot.default_flow,
                };
              }
              return bot;
            }
          );
        }
      })
      .addCase(getFinetuningTrainingLoss.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload.status;
      })
      .addCase(getFinetuningTrainingLoss.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(getFinetuningTrainingLoss.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
      })
      .addCase(getDefaultCombinations.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload.status;
      })
      .addCase(cancelFinetuning.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload.status;
      })
      .addCase(cancelFinetuning.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(cancelFinetuning.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.isFinetuning = false;
      })
      .addCase(generateQuestions.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload.status;
      })
      .addCase(generateQuestions.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(generateQuestions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
      })
      .addCase(getInitCost.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload.status;
      })
      .addCase(getInitCost.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(getInitCost.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload;
      })
      .addCase(getBotbyID.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload.status;
      })
      .addCase(getBotbyID.pending, (state) => {
        state.isLoading = false;
      })
      .addCase(getBotbyID.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload;
        const bot_id = action.meta.arg.bot_id; // Get bot_id from meta
        const newApp = action.payload.bot; // Extract new golden_responses from payload

        if (state.chatbots && !Array.isArray(state.chatbots)) {
          // Find the bot in the array by matching _id.$oid with botId
          const botIndex = state.chatbots.combinations.findIndex(
            (bot) => bot._id?.$oid === bot_id
          );
          if (botIndex !== -1) {
            state.chatbots.combinations[botIndex] = {
              ...state.chatbots.combinations[botIndex],
              ...newApp,
            };
          }
        }
      })
      .addCase(getBotsbyUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBotsbyUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.gettingCombinations = false;
        // state.chatbots = action.payload;
        // Access the 'combinations' array from the action.payload
        const combinations = action?.payload?.bots || [];
        // Sort by `created_at.$date` in descending order (newest first)
        const sortedBots = [...combinations].sort((a, b) => {
          const dateA = a.created_at?.$date || 0;
          const dateB = b.created_at?.$date || 0;
          return dateB - dateA; // Descending order (newest to oldest)
        });
        // Update the state
        state.chatbots = {
          ...action.payload,
          combinations: sortedBots,
        }; // Override combinations with reversed array
      })
      .addCase(getBotsbyUser.rejected, (state, action) => {
        state.message = action.payload;
        state.isLoading = false;
        state.isError = true;
        state.gettingCombinations = false;
      })
      .addCase(addCombination.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addCombination.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.gettingCombinations = false;
      })
      .addCase(addCombination.rejected, (state, action) => {
        state.message = action.payload;
        state.isLoading = false;
        state.isError = true;
        state.gettingCombinations = false;
      })
      .addCase(updateCombination.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateCombination.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.gettingCombinations = false;
      })
      .addCase(updateCombination.rejected, (state, action) => {
        state.message = action.payload;
        state.isLoading = false;
        state.isError = true;
        state.gettingCombinations = false;
      })
      .addCase(getSpecificToolById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSpecificToolById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.gettingCombinations = false;
      })
      .addCase(getSpecificToolById.rejected, (state, action) => {
        state.message = action.payload;
        state.isLoading = false;
        state.isError = true;
        state.gettingCombinations = false;
      })
      .addCase(getAgentCombinations.pending, (state) => {
        state.isLoading = true;
        state.gettingAgentCombinations = true;
      })
      .addCase(getAgentCombinations.fulfilled, (state, action) => {
        state.agent_combinations = action.payload?.combinations || [];
        state.agent_combination_length = action.payload?.length || 0;

        // Only update filter_values if present
        if (action.payload?.filter_values) {
          state.agent_filter_values = action.payload.filter_values;
        }

        state.isLoading = false;
        state.gettingAgentCombinations = false;
      })
      .addCase(getAgentCombinations.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.gettingAgentCombinations = false;
        state.message = action.payload;
      })
      .addCase(runAgentEvals.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(runAgentEvals.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        // replace the single updated combination
        state.agent_combinations = state.agent_combinations.map((c) =>
          c._id["$oid"] === payload._id["$oid"] ? payload : c
        );
      })
      .addCase(runAgentEvals.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isError = true;
        state.message = payload;
      })
      .addCase(runParserEvals.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(runParserEvals.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        // Update parser_combinations with the new combination result
        state.parser_combinations = state.parser_combinations.map(
          (combination) =>
            combination._id["$oid"] === action.payload.combination._id["$oid"]
              ? action.payload.combination
              : combination
        );
      })
      .addCase(runParserEvals.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getNeoProjectsByUserId.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getNeoProjectsByUserId.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload;
        // state.token = action.payload.token;
      })
      .addCase(getNeoProjectsByUserId.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(generateBotReportNeo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(generateBotReportNeo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload;
        // state.token = action.payload.token;
      })
      .addCase(generateBotReportNeo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getNeoSessionById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getNeoSessionById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload;
        // state.token = action.payload.token;
      })
      .addCase(getNeoSessionById.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(updateNeoProjectName.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateNeoProjectName.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload;
        // state.token = action.payload.token;
      })
      .addCase(updateNeoProjectName.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteNeoProject.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteNeoProject.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload;
        // state.token = action.payload.token;
      })
      .addCase(deleteNeoProject.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(clearEvaluationCache.fulfilled, (state) => {
  // Cache cleared successfully
})
.addCase(clearSpecificEvaluationFromCache.fulfilled, (state) => {
  // Specific evaluation cleared from cache successfully
})
.addCase(checkEvaluationCached.fulfilled, (state, action) => {
  // Cache status checked successfully
})
.addCase(getEvaluationCacheSize.fulfilled, (state, action) => {
  // Cache size retrieved successfully
});
  },
});
export const {
  resetChatbot,
  resetBotState,
  sortByProperty,
  sortApplicationsByCreatedAt,
  setCombinationUsed,
  deleteCombinatioSet,
  setDefaultCombination,
  resetCombinations,
  deleteBotFromTemplateBots,
  clearFilterValues,
  setUploadProgress,
  setIsUploading,
  setUploadError,
  resetUploadState,
  clearAllAgentCombinationFilters,
  setAgentCombinationSortOrder,
  setAgentCombinationFilters,
} = chatbotSlice.actions;
export default chatbotSlice.reducer;
